
import { Component, ActionButtonConfig, FormModalMixins, appConst, Watch } from "@/lib";
import ProductName from "@/store/modules/system/productname/entity";
@Component
export default class CreateProductName extends FormModalMixins {
  model = new ProductName();
  created() {
    Object.assign(this.config, { modelTitleL: "Action.Add", labelWidth: 150, okAction: "system/productname/create" });
  }

  private trimCode() {
    const code: any = this.model.code;
    if (typeof code === "string") {
      const trimmed = code.trim();
      if (trimmed !== code) this.model.code = trimmed;
    }
  }

  @Watch("model.code")
  onCodeChanged() {
    this.trimCode();
  }

  @Watch("config.isShow")
  onVisibleChanged(value: boolean) {
    if (!value) return;
    this.trimCode();
  }

  get unitList() {
    return this.getCodeListByCategory(appConst.codeCategory.unit);
  }
}
